import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Model,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.catalog}assemblingmodels/bySkus`;

interface GetAssemblingModelsBySkusCommandPayload {
  skus: string[];
  sellerId: string;
}

async function getAssemblingModelsBySkusCommand({
  skus,
  sellerId,
}: GetAssemblingModelsBySkusCommandPayload): Promise<
  BackResponse<Model[]> | BackResponseFailure
> {
  try {
    const response = await apiCall<BackResponse<Model[]>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        skus,
        sellerId,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getAssemblingModelsBySkusCommand;
